if (!customElements.get("quick-add-selects")) {
  customElements.define(
    "quick-add-selects",
    class QuickAddSelects extends HTMLElement {
      constructor() {
        super();
        this.quickAddForm = document.querySelector(`#quick-add-${this.dataset.section}${this.dataset.product}`);
        this.addEventListener("change", this.onVariantChange);
      }

      onVariantChange() {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, "", false);
        this.removeErrorMessage();
        this.updateVariantStatuses();

        if (!this.currentVariant) {
          this.toggleAddButton(true, "", true);
          this.setUnavailable();
        } else {
          this.updateVariantInput();
          this.renderProductInfo();
        }
      }

      updateOptions() {
        this.options = Array.from(
          this.querySelectorAll("select"),
          (select) => select.value
        );
      }

      updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
          return !variant.options
            .map((option, index) => {
              return this.options[index] === option;
            })
            .includes(false);
        });
      }

      updateVariantInput() {
          const input = this.quickAddForm.querySelector('input[name="id"]');
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event("change", { bubbles: true }));
      }

      updateVariantStatuses() {
        const selectedOptionOneVariants = this.variantData.filter(
          (variant) => this.querySelector(":checked").value === variant.option1
        );
        const inputWrappers = [
          ...this.querySelectorAll(".product-form__input"),
        ];
        inputWrappers.forEach((option, index) => {
          if (index === 0) return;
          const optionInputs = [
            ...option.querySelectorAll('input[type="radio"], option'),
          ];
          const previousOptionSelected =
            inputWrappers[index - 1].querySelector(":checked").value;
          const availableOptionInputsValue = selectedOptionOneVariants
            .filter(
              (variant) =>
                variant.available &&
                variant[`option${index}`] === previousOptionSelected
            )
            .map((variantOption) => variantOption[`option${index + 1}`]);
          this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
      }

      setInputAvailability(listOfOptions, listOfAvailableOptions) {
        listOfOptions.forEach((input) => {
          if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
            input.innerText = input.getAttribute("value");
          } else {
            input.innerText =
              window.variantStrings.unavailable_with_option.replace(
                "[value]",
                input.getAttribute("value")
              );
          }
        });
      }

      removeErrorMessage() {
        const productForm = this.productForm;
        if (productForm) productForm.handleErrorMessage();
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        if (!this.quickAddForm) return;
        const addButton = this.quickAddForm.querySelector('[name="add"]');
        const addButtonText = this.quickAddForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;
      }

      renderProductInfo() {
        const requestedVariantId = this.currentVariant.id;
        console.log(requestedVariantId)
        // const sectionId = this.dataset.originalSection
        //   ? this.dataset.originalSection
        //   : this.dataset.section;

        const sectionId = 'quick-add'
    
        fetch(
          `${this.dataset.url}?variant=${requestedVariantId}&section_id=${sectionId}`
        )
          .then((response) => response.text())
          .then((responseText) => {
            // prevent unnecessary ui changes from abandoned selections
            if (this.currentVariant.id !== requestedVariantId) return;
    
            const html = new DOMParser().parseFromString(responseText, "text/html");

            console.log(html)
    
            // const addButtonUpdated = html.getElementById(
            //   `ProductSubmitButton-${sectionId}`
            // );
            const addButtonUpdated = html.querySelector('.quick-add__submit');
            console.log(addButtonUpdated)
            this.toggleAddButton(
              addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
              window.variantStrings.soldOut
            );
          });
      }

      setUnavailable() {
        const button = this.quickAddForm;
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');

        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
      }

      getVariantData() {
        this.variantData =
          this.variantData ||
          JSON.parse(
            this.querySelector('[data-product-variants]').textContent
          );
        return this.variantData;
      }
    }
  );
}
